import { WorkspacePropertiesAdapter } from '@pique/core/modules/properties';
import { useLiveData, useService } from '@toeverything/infra';
import { memo, useMemo } from 'react';

import { BulbIcon } from '../../icons/BulbIcon';
import { useManager } from './common';
import * as styles from './meeting-overview.css';

export const PageOverviewRow = memo(function PageOverviewRow() {
  const docId = useManager().pageId;
  const adapter = useService(WorkspacePropertiesAdapter);
  const overview$ = useMemo(
    () => adapter.pageOverview$(docId),
    [adapter, docId]
  );
  const text = useLiveData(overview$) || '';

  const hasText = typeof text === 'string' && text.trim().length > 0;
  if (!hasText) return null;

  return (
    <div className={styles.container} data-testid="page-overview">
      <div className={styles.header}>
        <BulbIcon size={16} />
        Overview
      </div>
      <div className={styles.text}>{text}</div>
    </div>
  );
});
